var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogomarkFlueidpro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 106 178",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.452 134.638h59.71c8.336 0 15.1-6.718 15.1-14.99 0-8.288-6.764-15-15.1-15h-59.71V90.095c0-32.913 26.785-59.689 59.71-59.689 8.336 0 15.1-6.719 15.1-14.99 0-8.28-6.764-15-15.1-15C40.59.415.262 40.644.262 90.094v82.523c8.79 1.516 18.873 3.153 30.19 4.798v-42.777",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogomarkFlueidpro);
export default __webpack_public_path__ + "static/media/logomark-flueidpro.1a48c739c39c9940d0605b70a6f2e36c.svg";
export { ForwardRef as ReactComponent };